import React, { useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { MENH_GIA} from "../../../../../utils/kiemkeUtils";
import { formatNumber2 } from "../../../../../utils/currencyFormat";

export const ModalChiTiet = ({ show, onHide, item }) => {
    const {
        banks,
        cashDetails,
        tongTienMat,
        tongTienNganHang,
        tongCong,
        chenhLech
    } = useMemo(() => {
        if (!item) {
            return {
                banks: [], cashDetails: [], tongTienMat: 0,
                tongTienNganHang: 0, tongCong: 0, chenhLech: 0
            };
        }

        const allBanks = item.ChiTiet?.filter(c => c.LoaiTienTe === true) || [];
        const allCash = item.ChiTiet?.filter(c => c.LoaiTienTe === false) || [];
        const allCashDetails = MENH_GIA.map(menhGia => {
            const found = allCash.find(c => c.MenhGia === menhGia.label);
            const soLuong = found ? found.SoLuong : 0;
            return {
                ...menhGia,
                SoLuong: soLuong,
                ThanhTien: soLuong * menhGia.value
            };
        });
        const ttNH = allBanks.reduce((sum, b) => sum + (Number(b.SoLuong) || 0), 0);
        const ttMat = allCashDetails.reduce((sum, c) => sum + c.ThanhTien, 0);
        const ttCong = item.TotalKiemKe || 0;
        const cl = ttCong - (item.QuyTienMat || 0);
        return {
            banks: allBanks,
            cashDetails: allCashDetails,
            tongTienMat: ttMat,
            tongTienNganHang: ttNH,
            tongCong: ttCong,
            chenhLech: cl
        };

    }, [item]);

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="modal-dialog modal-xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold" id="myModalLabel16">
                    <span className="btn-icon-right">
                        <i className="fa-solid fa-circle-info" style={{ marginRight: '10px' }}></i>
                    </span>
                    Chi tiết Phiếu Kiểm Kê
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={onHide}
                >
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>

            <Modal.Body className="">
                <div className="form form-horizontal">
                    <div className="form-body">
                        {/* Thông tin chung */}
                        <div className="form-group row">
                            <label className="col-md-3 label-control color7-bold">Loại kiểm kê</label>
                            <div className="col-md-9">
                                <p className="form-control-static">{item.LoaiKiemKe || '---'}</p>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-3 label-control color7-bold">Ngày kiểm kê</label>
                            <div className="col-md-9">
                                <p className="form-control-static">{item.Time || '---'}</p>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-3 label-control color7-bold">Người kiểm kê</label>
                            <div className="col-md-9">
                                <p className="form-control-static">{item.NguoiKiemKe || '---'}</p>
                            </div>
                        </div>

                        <hr />

                        {/* I. Dòng tiền hệ thống */}
                        <div className="form-group row">
                            <strong className="col-md-12 label-control color7-bold">
                                I. Dòng tiền trong hệ thống:
                                <span style={{ color: 'red', marginLeft: '10px' }}>{formatNumber2(item.QuyTienMat)} (vnđ)</span>
                            </strong>
                        </div>

                        {/* II. Tiền gửi ngân hàng */}
                        <div className="form-group row">
                            <strong className="col-md-12 label-control color7-bold">II. Kiểm kê tiền gửi ngân hàng</strong>
                            <div className="col-md-12">
                                <div className="custom-table-wrapper" style={{ overflowX: "auto", minWidth: 'auto', maxHeight: 200, overflowY: 'auto' }}>
                                    <div className="table-headers" style={{ display: 'flex', alignItems: 'center' }}>
                                        <div className="custom-table-header text-left" style={{ width: '60%' }}><p>Tên ngân hàng / Ví</p></div>
                                        <div className="custom-table-header text-right" style={{ width: '40%', paddingRight: '520px'  }}><p>Số tiền</p></div>
                                    </div>
                                    <div className="custom-table-body">
                                        {banks.length > 0 ? banks.map((n, idx) => (
                                            <div className="custom-table-row" key={idx}>
                                                <div className="custom-table-cell" style={{ width: '60%' }}><p>{n.MenhGia}</p></div>
                                                <div className="custom-table-cell" style={{ width: '40%',justifyContent: 'flex-end', paddingRight: '515px' }}><p>{formatNumber2(n.SoLuong)}</p></div>
                                            </div>
                                        )) : (
                                            <div className="custom-table-row"><p style={{ textAlign: 'center', width: '100%' }}>Không có dữ liệu</p></div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* III. Kiểm kê tiền mặt*/}
                        <div className="form-group row">
                            <strong className="col-md-12 label-control color7-bold">III. Kiểm kê tiền mặt</strong>
                            <div className="col-md-12">
                                <div className="custom-table-wrapper" style={{ overflowX: "auto", minWidth: 'auto' }}>
                                    <div className="table-headers" style={{ display: 'flex', alignItems: 'center' }}>
                                        <div className="custom-table-header text-left" style={{ width: '30%' }}><p>Mệnh giá</p></div>
                                        <div className="custom-table-header text-right" style={{ width: '30%', paddingRight: '20px' }}><p>Số lượng (tờ)</p></div>
                                        <div className="custom-table-header text-right" style={{ width: '40%' , paddingRight: '30px'}}><p>Thành tiền</p></div>
                                    </div>
                                    <div className="custom-table-body" style={{ maxHeight: 300, overflowY: 'auto' }}>
                                        {cashDetails.map((m) => (
                                            <div className="custom-table-row" key={m.value}>
                                                <div className="custom-table-cell " style={{ width: '30%' }}><p>{m.label}</p></div>
                                                <div className="custom-table-cell" style={{ width: '30%',justifyContent: 'flex-end', paddingRight: '15px'  }}><p>{formatNumber2(m.SoLuong)}</p></div>
                                                <div className="custom-table-cell" style={{ width: '40%', justifyContent: 'flex-end', paddingRight: '15px'  }}><p>{formatNumber2(m.ThanhTien)}</p></div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* IV. Tổng cộng và Chênh lệch - DÙNG LAYOUT NÀY CHO CẢ 2 MODAL */}
                        <div className="form-group row" style={{ backgroundColor: '#f5f7fa', padding: '10px 15px', display: 'flex', alignItems: 'flex-start' }}>

                            {/* Cột Lớn Bên Trái */}
                            <div style={{ flex: 1, paddingRight: '15px', borderRight: '1px solid #ddd' }}>

                                {/* Dòng Tổng tiền NH */}
                                <div className="row" style={{ marginBottom: '10px' }}>
                                    <label className="col-md-6 label-control color7-bold">Tổng tiền NH (II):</label>
                                    <div className="col-md-6 text-right"><p><strong>{formatNumber2(tongTienNganHang)}</strong></p></div>
                                </div>

                                {/* Dòng Tổng tiền mặt */}
                                <div className="row">
                                    <label className="col-md-6 label-control color7-bold">Tổng tiền mặt (III):</label>
                                    <div className="col-md-6 text-right"><p><strong>{formatNumber2(tongTienMat)}</strong></p></div>
                                </div>

                            </div>

                            {/* Cột Lớn Bên Phải */}
                            <div style={{ flex: 1, paddingLeft: '15px' }}>

                                {/* Dòng TỔNG CỘNG */}
                                <div className="row" style={{ marginBottom: '10px' }}>
                                    <label className="col-md-6 label-control color7-bold">TỔNG CỘNG KIỂM KÊ (II + III):</label>
                                    <div className="col-md-6 text-right"><p style={{ color: 'blue', fontWeight: 'bold', fontSize: 16 }}>{formatNumber2(tongCong)}</p></div>
                                </div>

                                {/* Dòng CHÊNH LỆCH */}
                                <div className="row">
                                    <label className="col-md-6 label-control color7-bold">CHÊNH LỆCH (Tổng - Hệ thống):</label>
                                    <div className="col-md-6 text-right"><p style={{ color: 'red', fontWeight: 'bold', fontSize: 16 }}>{formatNumber2(chenhLech)}</p></div>
                                </div>

                            </div>
                        </div>

                        {/* Ghi chú*/}
                        <div className="form-group row">
                            <label className="col-md-3 label-control color7-bold">Ghi chú / Lý do chênh lệch</label>
                            <div className="col-md-9">
                                <p className="form-control-static" style={{ whiteSpace: 'pre-wrap' }}>
                                    {item.GhiChu || '---'}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onHide}
                >
                    <span>
                        <i className="mdi mdi-close"></i>
                    </span>
                    &nbsp; Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};
